import { graphql, useStaticQuery } from 'gatsby'
import React, { type FC, type PropsWithChildren } from 'react'

import { SectionIconic } from './section-iconic'

const SectionTemplateIconic1: FC<{ className: string } & PropsWithChildren> = ({
  className,
  children,
}) => {
  const { backgroundImage } =
    useStaticQuery<Queries.SectionTemplateIconic1Query>(graphql`
      query SectionTemplateIconic1 {
        backgroundImage: contentfulAsset(
          contentful_id: { eq: "3X4YX872HDEZ0RcQIh6jr" }
          metadata: {
            tags: { elemMatch: { contentful_id: { eq: "scopeWebsite" } } }
          }
        ) {
          ...ContentfulAvifAsset
        }
      }
    `)

  return (
    <SectionIconic backgroundImage={backgroundImage} className={className}>
      {children}
    </SectionIconic>
  )
}

export default SectionTemplateIconic1
